import { Link } from '@chakra-ui/layout';
import { isToday } from 'date-fns';
import mixpanel from 'mixpanel-browser';
import { useLocation } from 'react-router-dom';

import { useContactSalesMutation, useGetLoggedInUser } from '@revelio/auth';
import { CTAInteractionTrackingEvents, type PageTitles } from '@revelio/core';

import { useToast } from '../../shared/hooks/useToast';
import {
  toastContactSalesAlreadyNotified,
  toastContactSalesRequestError,
  toastContactSalesRequestSuccess,
} from './contact-sales-toast';
import { useFreeTrialAlertModalState } from './useFreeTrialAlertModalState';

const TrialUpgradeLink = ({
  page,
  linkText = 'upgrade your trial',
  toastIdClose = '',
}: {
  page?: PageTitles;
  linkText?: string;
  toastIdClose?: string;
}) => {
  const toast = useToast();
  const location = useLocation();
  const { loggedInUser } = useGetLoggedInUser();
  const { email } = loggedInUser;
  const { days } = useFreeTrialAlertModalState();
  const mixpanelTrialUpgrade = () => {
    mixpanel.track(CTAInteractionTrackingEvents.TRIAL_UPGRADE, {
      days_left: days,
      page: page || location.pathname,
    });
  };
  const { mutate: contactSales } = useContactSalesMutation();

  const handleContactSales = () => {
    const contactedSales = localStorage.getItem('contacted-sales') || '';
    if (!contactedSales || !isToday(new Date(contactedSales))) {
      mixpanelTrialUpgrade();
      contactSales(
        {
          email,
          trialUpgrade: page || location.pathname,
        },
        {
          onSuccess: () => {
            localStorage.setItem('contacted-sales', new Date().toDateString());
            toastContactSalesRequestSuccess(toast);
            if (toastIdClose) {
              toast.close(toastIdClose);
            }
          },
          onError: () => {
            toastContactSalesRequestError(toast);
          },
        }
      );
    } else {
      toastContactSalesAlreadyNotified(toast);
      if (toastIdClose) {
        toast.close(toastIdClose);
      }
    }
  };
  return (
    <Link
      color="blue.500"
      textDecoration="underline"
      cursor="pointer"
      onClick={handleContactSales}
      fontWeight="600"
      _hover={{
        textDecoration: 'none',
        color: 'blue.600',
      }}
    >
      {linkText}
    </Link>
  );
};

export default TrialUpgradeLink;
